/*import LockScroll from './LockScroll';*/

export default class Popup {
    constructor(popup) {
        this.name = $(popup).data('name');
        this.isOpen = false;
        this.DOM = {
            ROOT: $(popup),
            CLOSE: $('.js-popup-close', popup),
            INNER: $(popup).find('.popup__container'),
        };
        this.CLASS = {
            OPENED: '_opened',
            CLOSE: '.js-popup-close'
        };

        this.init();
    }


    // события
    init() {
        App.document.on('click', '[data-popup="' + this.name + '"]', (e) => {
            e.preventDefault();
            $(e.currentTarget).trigger('popup:open', {
                name: this.name
            });
        });

        this.DOM.ROOT.on('click', this.CLASS.CLOSE, (e) => {
            e.preventDefault();
            $(e.currentTarget).trigger('popup:close', {
                name: this.name
            });
        });

        this.DOM.ROOT.on('click', (e) => {
            // e.preventDefault();
            if (!$(e.target).closest('.popup__container').length) {
                $(e.currentTarget).closest('.js-popup').find(this.CLASS.CLOSE).trigger('popup:close', {
                    name: this.name
                });
            }
        });

        // закрываем попап по всплытию события popup:close
        App.document.on('popup:close', (e, data) => {
            if (data.name == this.name && this.isOpen) {
                this.close();
            }
        });

        // открываем попап
        App.document.on('popup:open', (e, data) => {
            if (data.name == this.name && !this.isOpen) {
                this.open();
            }
        });

        if (this.DOM.ROOT.hasClass(this.CLASS.OPENED)) {
            this.open();
        }

        App.document.on('keyup', function (e) {
            if (e.code === 'Escape' && $('.js-popup._opened').length) {
                $('.js-popup._opened').trigger('popup:close', {
                    name: $('.js-popup._opened').data('name')
                });
            }
        });
    }

    open() {
        this.isOpen = true;
        this.DOM.ROOT.addClass(this.CLASS.OPENED);
        setTimeout(() => this.DOM.ROOT.trigger('popup:opened', {
            name: this.name
        }), 300);
        App.lockScroll.lock();
    }

    close() {
        this.isOpen = false;
        this.DOM.ROOT.removeClass(this.CLASS.OPENED);

        if (this.name === 'review-popup') {
            setTimeout(() => {
                this.DOM.ROOT.find('.review-popup__name').html('');
                this.DOM.ROOT.find('.review-popup__company').html('');
                this.DOM.ROOT.find('.review-popup-text-inner').html('');
            }, 300);
        }

        if (this.DOM.ROOT.find('.success-form')) {
            this.DOM.ROOT.find('.success-form').removeClass('success-form');
        }

        if (this.DOM.ROOT.find('.js-form')) {
            this.DOM.ROOT.find('.js-form').removeClass('_form-success _form-message');
        }

        if (this.DOM.ROOT.find('.js-success-message-wrap')) {
            this.DOM.ROOT.find('.js-success-message-wrap').removeClass('_active');
        }

        if (this.DOM.INNER.find('input[type="text"], textarea').length) {
            this.DOM.INNER.find('input[type="text"], textarea').val('');
            this.DOM.INNER.find('input[type="text"], textarea').closest('.js-input-wrap').removeClass('_focused');
        }

        // setTimeout(() => {
        this.DOM.ROOT.trigger('popup:closed', {
            name: this.name
        });
        App.lockScroll.unlock();
        // }, 300);
    }
}

$('.js-popup').each(function () {
    new Popup(this);
});

App.H.addClass('popup-inited');

App.W.on('popup:dinamic_init', function () {
    $('.js-popup.dinamic').each(function () {
        new Popup(this);
    });
});
